import React from 'react'
import { NavLink } from 'react-router-dom'
import './index.scss'

const SideBar = (props) => {
    const plateArr = props.plates;
    return (
        <div className="SideBar">
            {
                plateArr.map((item, index) => (<NavLink className="side-opt" activeClassName="active" key={index} isActive={(match, location) => {
                    return location.pathname === item.url
                }} to={item.url}>{item.text}</NavLink>))
            }
        </div>
    )
}

export default SideBar;


// WEBPACK FOOTER //
// ./src/components/SideBar/index.js